import styled from 'styled-components';
import { generateClampFromMax } from '@/utils/styling';
import { medias } from '@/utils/sizes';

export const ProjectsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${generateClampFromMax(128)};
`;

export const TopContent = styled.div`
  display: flex;
  justify-content: space-between;
  /* border-top: 1px solid var(--c-border); */
  padding: var(--spacing-component-inner) 0;
`;

export const ProjectsListsContainer = styled.div`
  opacity: 0;
  position: relative;
  transition: opacity var(--tr-base) ease-in-out;

  &[data-display='true'] {
    opacity: 1;
  }

  ${medias.max.mobile} {
    padding-top: 20px;
  }

  .loader-additional-list {
    position: relative;

    > div:first-child {
      display: none;
    }

    > div:last-child {
      padding-top: var(--spacing-component-inner);
    }
  }

  &:has(.is-additional-list) {
    .not-additional-list {
      margin-bottom: 0; 
    }
  }
`;

export const ProjectsListsWrapper = styled.div`
  position: relative;

  .loader-initial-list {
    position: absolute;
    opacity: 0;
    top: 0;
    width: 100%;
    left: 0;

    > div:first-child {
      height: var(--spacing-component-inner); 
    }
  }

  ${medias.min.tablet} {
    border-top: 1px solid var(--c-border);
  }
`

export const ArchivedProjectsLoaderContainer = styled.div`
  .loader-archived-additional-list {
    position: relative;

    > div:first-child {
      display: none;
    }

    > div:last-child {
      padding-top: 0;
      grid-template-columns: repeat(6, 1fr);
    }
  }
`;
